<div class="reset-wrap">
    <div class="row mt-2 justify-content-center">
        <div class="col-4 reset-box">
            <div class="reset-form p-3">
                <form [formGroup]="forgetPasswordForm!" (ngSubmit)="onSubmit()">
                    <div class="row reset-header mb-2 justify-content-center">
                        <div class="col-md-1 col-sm-12 p-0"></div>
                        <div class="col-md-10 col-sm-12 text-center">
                            <div class="float-left leaflet-logo-container" routerLink="">
                                <img src="/assets/img/header_logo.png" class="img-responsive logo leaflet-logo"
                                    alt="Leaflet" />
                            </div>
                        </div>
                        <div class="col-md-1 col-sm-12 p-0"></div>

                    </div>
                    <div class="row reset-sub-header">
                        <div class="col-md-1 col-sm-12 p-0"></div>
                        <div class="col-md-10 col-sm-12">
                            <h6 class="reset-text">Please provide your registered email address so we can send you the
                                reset link.</h6>
                        </div>
                        <div class="col-md-1 col-sm-12 p-0"></div>
                    </div>
                    <div class="reset-body">
                        <div class="row">
                            <div class="col-md-1 col-sm-12 p-0"></div>
                            <div class="col-md-10 col-sm-12 p-0 ">
                                <app-custom-input type="text" placeholder="Enter Email" fieldLabel="Email"
                                    fieldId="email" [fieldType]="resetFormGroupControls['email']"
                                    formControlName="email" [errorMessages]="errorMessages.email"
                                    [submitted]="submitted" ngDefaultControl>
                                </app-custom-input>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>

                        <div class="row reset-btn">
                            <div class="col-md-1 col-sm-12 p-0"></div>
                            <div class="col-md-10 col-sm-12 btn-block p-0">
                                <button type="submit" class="btn">
                                    Submit
                                </button>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>

                        <div class="row reset-wrap" style="padding:5px !important;">
                            <div class="col-md-1 col-sm-12"></div>
                            <div class="col-md-10 col-sm-12 reset-sub-wrap">
                                <span>Back to
                                    <a [routerLink]="['/login']" class="forgot-pass-link">Login
                                    </a>
                                </span>
                            </div>
                            <div class="col-md-1 col-sm-12 p-0"></div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>